import '../adapters/polyfill'
import Cookies from 'js-cookie'
import type { primitives } from '@adc/blueprint'

// Type definitions
interface UrlVars {
  [key: string]: string | undefined
}

function getUrlVars(): UrlVars {
  const vars: UrlVars = {}
  const hashes = window.location.href
    .slice(window.location.href.indexOf('?') + 1)
    .split('&')
  for (let i = 0; i < hashes.length; i++) {
    const hash = hashes[i].split('=')
    const key = hash[0].toLowerCase()
    vars[key] = hash[1]
  }
  return vars
}

function getCookie(name: string): string | null {
  const nameEQ = `${name}=`
  const cookieList = document.cookie.split(';')
  for (let i = 0; i < cookieList.length; i++) {
    let cookie = cookieList[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length)
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length)
    }
  }
  return null
}

function getUrn(user: primitives.AuctionUser): string {
  return user.logged_in && user.party_id
    ? `adc:party:${user.party_id}`
    : `adc:anonymous_session:${Cookies.get('BRID')}`
}

export { getUrlVars, getCookie, getUrn }
export type { UrlVars }
